<div class="modal-header">
    <h4 class="modal-title pull-left">Remarks</h4>
    <i class="fa fa-times-circle fa-2x" aria-hidden="true" (click)="bsModalRef?.hide()"></i>
</div>
<div class="modal-body">
    <section class="prInitiator">
        <div class="d-flex flex-column mb-4 mt-1">
            <ng-container>
                <form [formGroup]="statusForm" class="p-4">
                    <div class="row">
                        <label for="remarks" class="form-label text-small">Remarks</label>
                        <input type="textarea" name="remarks" [(ngModel)]="remarks" class="form-control" [error]="statusForm.get('remarks')">
                        <form-feedback [formGroup]="statusForm" field="remarks"></form-feedback>
                    </div>
                </form>
            </ng-container>
        </div>
    </section>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary me-2" (click)="submit()"
        [disabled]="!statusForm.valid">
        Submit
    </button>
</div>